import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

export const PlanSelectionStyles = {
  PlanSelection: styled.div`
    display: flex;
    align-items: center;
  `,
  Icon: css`
    margin-left: ${tokens.spacer.x1};
    color: ${tokens.color.primary_cta};
  `,
};
